export enum WageAndTravelGroup {
    Niether = 0,
    LostWage = 1,
    DonorExpense = 2,
    Both = 3
}